import React, { memo } from 'react';
import { string } from 'prop-types';
import Error from '@material-ui/icons/Error';
import { UTLabel } from '@widergy/energy-ui';

import styles from './styles';

const Maintenance = ({ message }) => (
  <div style={styles.container}>
    <Error style={styles.icon} />
    <UTLabel darkGray bold xxlarge>
      {message}
    </UTLabel>
  </div>
);

Maintenance.propTypes = {
  message: string
};

export default memo(Maintenance);
